import React from 'react'
import { BrandContext } from './brandProvider'
import { IProps, BrandOptions } from './index'

export const HeaderAndFooterBrandProvider = ({ children }: IProps): React.ReactElement => {
  return <BrandContext.Provider value={BrandOptions.default}>{children}</BrandContext.Provider>
}
